// extracted by mini-css-extract-plugin
module.exports =  {"section":"section--GdVoF","section-field":"section-field--RD6Xl","sectionField":"section-field--RD6Xl","title":"title--cKtm1"};